import i18next from 'i18next';
import moment from 'moment';
import 'moment/min/locales';
import CommonUtil from '../common/CommonUtil';
import { PAGE_DESC, PAGE_TITLE } from '../common/Foundation';
import { EVENT } from "../events/listEvents";
import $ from 'jquery';

const namespacesDefault = 'default';
const backendURL =  '/esthardsk/locales/';

/**
 * getI18nextConfig
 * 
 * Innit Object I18n
 * 
 */
export const getI18nextConfig = () => {

  resetLangsSessionStore();
  let currentLang;
  //let langOnBrowser = getLangBaseOnURLPath();
  let langOnBrowser = sessionStorage.getItem('lng') || 'en';
  var re = new RegExp("^([a-z]{2}|[a-z]{2}-[a-z]{2})$");
  if(re.test(langOnBrowser)){
      //// console.log("langOnBrowser", langOnBrowser)
      currentLang = langOnBrowser;
  }
  if (currentLang == null) {
    currentLang = 'en';
  }

  i18next.on('languageChanged', function(currentLang) {
    moment.locale(currentLang);
  });

  i18next.init({
    lng: currentLang,
    fallbackLng: 'en',
    debug: false,
    ns: namespacesDefault,
    defaultNS: namespacesDefault,
    fallbackNS: namespacesDefault,
    keySeparator: '_._'
  }, function (err, t) {
    // init set content

  });    
 
  //Because some keys in orther languages are not translate, so we need to load English to default
  if(currentLang !== 'en'){
     // call fallbackLng languague
    callFallBackLanguage(backendURL, 'en');
  }
 

  callAPIlAddLangToI18n(i18next, backendURL, currentLang).then(
      () => {
          storeLangToLocal(currentLang);
      }
  )  
  return i18next
}

/**
 * getLangBaseOnURLPath
 * 
 * Detect current language base on current URL
 * 
 */
export const getLangBaseOnURLPath = () => {
  let strUrl = window.location.href.replace(process.env.REACT_APP_ROUTER_BASE, "");
  let res = strUrl.split("/");
  let lang = res[3];
  return convertToCorrectedLang(lang);
}
/**
 * loadLanguage
 * Call api get data json data and innit data for Language
 * 
 * @param {*} lng 
 */
export const loadLanguage = (lng, isFireEvent) => {
  if (lng != null) {
    lng = convertToCorrectedLang(lng);
    let preLang = sessionStorage.getItem('lng');
    const isB2B = window.env && window.env.isB2B;
    if (CommonUtil.isIniFrame() && !isB2B) {
      const urlLang = getLangBaseOnURLPath();
      if(lng !== urlLang) {
        lng = urlLang;
      }
      translateLang(lng, isFireEvent, preLang);
    } else {
      if (preLang == null || preLang.toLowerCase() !== lng.toLowerCase()) {
        translateLang(lng, isFireEvent, preLang);
      } else {
        updateTitle();
      }
    }
  }
}

function translateLang(lng, isFireEvent, preLang) {
  storeLangToLocal(lng);
  let langResultTranslate = JSON.parse(sessionStorage.getItem('lng-' + lng.toLowerCase()));
  if (langResultTranslate == null) {

    callAPIlAddLangToI18n(i18next, backendURL, lng).then(
      () => {
        i18next.changeLanguage(lng, (err, t) => {
          if (err)
            return console.log('something went wrong loading', err);
          if (isFireEvent)
            fireEventLangChanged(preLang, lng);
        });

      }
    ).finally(() => {
      updateTitle();
    });
  } else {
    if (!i18next.store.data[lng]) {
      i18next.store.data[lng] = langResultTranslate;
      i18next.addResourceBundle(lng, namespacesDefault, langResultTranslate[namespacesDefault], true, true);
    }
    i18next.changeLanguage(lng, (err, t) => {
      if (err)
        return console.log('something went wrong loading', err);
      if (isFireEvent)
        fireEventLangChanged(preLang, lng);
    });
    updateTitle();
  }
}

function updateTitle() {
  const pageTitle = CommonUtil.getPageTitle();
  document.title = pageTitle;
  updateDescriptionTitle(pageTitle);
  updatePageKeywords();
  updatePageTitle();
  updatePageImage();
}

function updateDescriptionTitle(pageTitle) {
    if(CommonUtil.isPA()) {
        const currentPageDesc = PAGE_DESC[CommonUtil.getCurrentPage()];
        const originalKey = `${CommonUtil.getCurrentSkin()}.${currentPageDesc ? currentPageDesc : 'pageDesc'}`;
        const pageDesc = i18next.t(originalKey, pageTitle);

        let description = document.querySelector('meta[name="description"]');
        let ogDescription = document.querySelector('meta[name="og:description"]');
        if(description) {
          description.setAttribute('content', pageDesc);
          document.head.appendChild(description);
          ogDescription.setAttribute('content', pageDesc);
          document.head.appendChild(ogDescription);
        } else {
          description = document.createElement('meta');
          description.setAttribute('name', "description");
          description.setAttribute('content', pageDesc);
          document.head.appendChild(description);
          ogDescription = document.createElement('meta');
          ogDescription.setAttribute('name', "og:description");
          ogDescription.setAttribute('content', pageDesc);
          document.head.appendChild(ogDescription);
        }
        
    }
}

function updatePageKeywords(){
    if(CommonUtil.isPA()) {
        const currentPageDesc = PAGE_DESC[CommonUtil.getCurrentPage()];
        const originalKey = `${CommonUtil.getCurrentSkin()}.${currentPageDesc ? currentPageDesc :'pageKeywords'}`;
        const pageDesc = i18next.t(originalKey);

        let keywords = document.querySelector('meta[name="keywords"]');
        if(keywords) {
          keywords.setAttribute('content', pageDesc);
        } else {
          keywords = document.createElement('meta');
          keywords.setAttribute('name', "keywords");
          keywords.setAttribute('content', pageDesc);
        }
        document.head.appendChild(keywords);
    }
}
function updatePageTitle(){
    if(CommonUtil.isPA()) {
        const currentPageDesc = PAGE_DESC[CommonUtil.getCurrentPage()];
        const originalKey = `${CommonUtil.getCurrentSkin()}.${currentPageDesc ? currentPageDesc :'pageTitle'}`;
        const pageDesc = i18next.t(originalKey);

        let title = document.querySelector('meta[property="og:title"]');
        if(title) {
          title.setAttribute('content', pageDesc);
        } else {
          title = document.createElement('meta');
          title.setAttribute('property', "og:title");
          title.setAttribute('content', pageDesc);
        }
        document.head.appendChild(title);
    }
}
function updatePageImage(){
    if(CommonUtil.isPA()) {
        const currentPageDesc = PAGE_DESC[CommonUtil.getCurrentPage()];
        const originalKey = `${CommonUtil.getCurrentSkin()}.${currentPageDesc ? currentPageDesc :'pageImage'}`;
        const pageDesc = i18next.t(originalKey);

        let image = document.querySelector('meta[property="og:image"]');
        if(image) {
          image.setAttribute('content', pageDesc);
        } else {
          image = document.createElement('meta');
          image.setAttribute('property', "og:image");
          image.setAttribute('content', pageDesc);
        }
        document.head.appendChild(image);
    }
}

//Use for 1 file jsons
function callAPIlAddLangToI18n(i18next, pathUrl, lang) {
  if(lang == null || lang.length === 0){
     lang = 'en'
  }

  let url = pathUrl + lang.toLowerCase() + '/' + lang.toLowerCase() + '.json';
      // fix: call same request many times 
      return fetch(url)
        .then(res => res.json())
        .then(
          (result) => {
            i18next.store.data[lang] = result;
            i18next.addResourceBundle(lang, namespacesDefault, result[namespacesDefault], true, true);        
            sessionStorage.setItem('lng-' + lang.toLowerCase(), JSON.stringify(result));
          },

          (error) => {

          }
        );   
 
}

function resetLangsSessionStore() {
    let i = sessionStorage.length;
    while(i--) {
      let key = sessionStorage.key(i);
      var lngReg = new RegExp("^lng");
      if(lngReg.test(key)) {
        sessionStorage.removeItem(key);
      }  
    }
}

function callFallBackLanguage(pathUrl, lang) {
  if(lang == null || lang.length === 0){
     lang = 'en'
  }

  let url = pathUrl + lang.toLowerCase() + '/' + lang.toLowerCase() + '.json';
      // fix: call same request many times 
      return fetch(url)
        .then(res => res.json())
        .then(
          (result) => {
            sessionStorage.setItem('lng-' + lang.toLowerCase(), JSON.stringify(result));
          },

          (error) => {

          }
        );   
 
}

/**
 * convertToCorrectedLang
 * Ex:
 * convert from zh-cn to zh-CN
 * @param {*} lang 
 */
function convertToCorrectedLang(lang) {
   let langArray = lang.split("-");
  if(langArray.length >= 2){     
      return langArray[0]+'-'+langArray[1].toUpperCase();
  }
  else return lang 
}

function storeLangToLocal(lang){
    sessionStorage.setItem('lng', lang.toLowerCase());
    CommonUtil.saveCookie('lang', CommonUtil.toLocaleCode(lang.toLowerCase()), { path: "/", domain: CommonUtil.getSubDomain() })
    //// console.log("storeLangToLocal");
}
function fireEventLangChanged(preLang, newLang){
    if(preLang !== newLang) window.fireEvent(EVENT.LANGUAGE_CHANGE);
    //// console.log("fireEventLangChanged");
}



// WEBPACK FOOTER //
// ./src/app/common/i18nConfiguration.js